import {useQuery} from '@apollo/client';
import React from 'react';
import {QUERY_THEME_DETAIL} from './graphql';
import Query from '../../components/Query';
import Back from '../../components/Back';

const ThemeDetail = ({match}) => {
  const query = useQuery(QUERY_THEME_DETAIL, {variables: {id: match.params.id}});
  const obj = query.data ? query.data.themeDetail : null;

  const parts = obj ? obj.content.split('; ') : [];

  return (
    Query(query) || (
      <div className="ForumDetail container py-4">
        <div className="row align-items-center mb-4">
          <div className="col-auto">
            <Back />
          </div>
          <div className="col-auto ms-3 font-4">{obj ? obj.name : 'Загрузка ...'}</div>
        </div>
        <div className="row g-3 g-lg-4">
          <div className="col-12 col-lg-6">
            <div className="list-group bg-white">
              {obj.topics.map((topic, idx) => (
                <div key={topic.id} className="list-group-item py-3">
                  <span>{idx + 1}. </span>
                  <span className="col">{topic.name}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="col-12 col-lg-6">
            <div className="row bg-white border rounded p-4">
              {parts.map((part, idx) => (
                <div key={idx} className="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4">
                  {part}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default ThemeDetail;
